import { lazy } from 'react';

export const LazyMicrosoftSelfSignPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--microsoft-self-sign-page" */ './microsoft-self-sign-page'
    ),
);
